import { Directive, Input, OnChanges, SimpleChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { UtilsService } from '../services/utils.service';

@Directive({
  selector: '[hasPermission]',
  standalone: true
})

export class HasPermissionDirective  {

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private utilsService: UtilsService,
  ) {
  }

  @Input()
  operation: 'AND' | 'OR' = 'OR';

  @Input()
  hasPermission?: string[];


  ngOnInit() {
    this.hasPermissionCompute(this.hasPermission);
  }

  @Input()
  private hasPermissionCompute(perms?: string[]) {
    let toShow = this.operation === 'AND';
    if (perms !== undefined) {
      perms.forEach(perm => {
        if (this.operation === 'AND') {
          toShow = toShow && this.utilsService.checkPermission(perm);
        }
        else {
          toShow = toShow || this.utilsService.checkPermission(perm);
        }
      });
    }
    
    if (toShow) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

}
